module.exports = __webpack_public_path__ + "img/jonathan.1d3afaa0.png";